var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showViewer)?_c('ElImageViewer',{attrs:{"on-close":_vm.closeViewer,"urlList":_vm.urlList,"z-index":_vm.zIndex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }